import * as yup from "yup"

export default yup.object().shape({
  role: yup
    .number()
    .required("Must choose role"),
  email: yup
    .string()
    .email("Must provide a valid email")
    .required("Must provide a valid email"),
  phone: yup
    .string(),
  password: yup
    .string()
    .required("Must provide a password (min. 5 char.)")
    .min(5, "Must provide a password (min. 5 char.)"),
  password_confirm: yup
    .string()
    .required("Passwords must match (min. 5 char.)")
    .min(5, "Passwords must match (min. 5 char.)")  
})
